

/////////////////////////////////////////////////////////////////////////
// TEXT HELPERS /////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const TextHelpers = {

  init: function(game) {

    this.game = game;

    this._extensions();
  },

  createBitmapTextField: function(x, y, styles, text, group) {

    var bmpText = group.game.add.bitmapText(x, y, styles.font, text, styles.fontSize, group);
    bmpText.tint = styles.fill;
    bmpText.align = styles.align || 'left';

    return bmpText;
  },

  _extensions: function() {

    // EXTEND cache to allow bitmap fonts on another atlas
    Phaser.Cache.prototype.addBitmapFontByAtlas = function (key, sheetKey, sheetFrame, atlasData, atlasType, xSpacing, ySpacing) {

      var obj = {
          font: null,
          base: this.game.cache.getBaseTexture(sheetKey)
      };

      if (xSpacing === undefined) { xSpacing = 0; }
      if (ySpacing === undefined) { ySpacing = 0; }

      // bind the atlas data to the frame on the 'sheet'
      var frameData = this.game.cache.getFrameByName(sheetKey, sheetFrame);
      var offsetx = frameData.x - frameData.spriteSourceSizeX;
      var offsety = frameData.y - frameData.spriteSourceSizeY;

      // only works with XML for now
      var xml = atlasData;
      var info = xml.getElementsByTagName('info')[0];
      var common = xml.getElementsByTagName('common')[0];

      var letters = xml.getElementsByTagName('char');

      for (var i = 0; i < letters.length; i++)
      {
          var x = parseInt(letters[i].getAttribute('x'), 10);
          var y = parseInt(letters[i].getAttribute('y'), 10);

          letters[i].setAttribute('x', x+offsetx);
          letters[i].setAttribute('y', y+offsety);
      }


      if (atlasType === 'json')
      {
          obj.font = Phaser.LoaderParser.jsonBitmapFont(atlasData, obj.base, xSpacing, ySpacing);
      }
      else
      {
          obj.font = Phaser.LoaderParser.xmlBitmapFont(atlasData, obj.base, xSpacing, ySpacing);
      }



      this._cache.bitmapFont[key] = obj;

    };    
  }      
};

export default TextHelpers;






// WEBPACK FOOTER //
// ./app/src/utils/misc/TextHelpers.js